


















































import Vue from "vue";
import _ from "lodash";

import { Gender, StorageBusinessType, AttachmentCode, NationalityType } from "@/scripts/enums";
import { currentStudentBasicInfo, currentStudentIdentityInfo, updateCurrentStudentBasicInfo } from "@/api/my";
import UploadMixin from "@/mixins/upload-mixin";
import BasicInfoCell from "@/views/my/info/BasicInfoCell.vue";
import IdentityInfoCell from "@/views/my/info/IdentityInfoCell.vue";
import { createNamespacedHelpers } from "vuex";

const { mapGetters, mapActions } = createNamespacedHelpers("config");

export default Vue.extend({
    name: "Info",
    components: { BasicInfoCell, IdentityInfoCell },
    mixins: [UploadMixin],
    data() {
        return {
            isBasicInfoEdit: false,
            isIdentityEdit: false,
            isIDCardEdit: false,
            isForeign: false,
            info: {
                name: "",
                englishName: "",
                gender: Gender.MALE,
                phone: "",
                email: "",
                birthplace: "",
                countryCode: "",
                identityType: "",
                identityNo: "",
                nationalityType: NationalityType.DOMESTIC,
                identity: {},
                identityBack: {},
                idPhoto: {},
                avatarResource: {},
                avatarFileKey: "",
                user: {
                    englishName: "",
                    phone: ""
                }
            },
            idCardFront: {},
            idCardBack: {},
            idPhoto: {},
            showPicker: false,
            submitDisabled: true,
            showAvatarPreview: false,
            avatar: {}
        };
    },
    computed: {
        ...mapGetters(["orgConfig"]),
        avatarImage(): string {
            return this.getImageSrc(this.avatar, `default_avatar_${this.info.gender.toLowerCase()}`);
        },
        idPhotoImage(): string {
            return this.getImageSrc(this.idPhoto, "id-photo-default");
        },
        idCardImage(): string {
            return this.getImageSrc(this.idCardFront, "default-identity-img");
        },
        idCardBackImage(): string {
            return this.getImageSrc(this.idCardBack, "default-identity-back-img");
        },
        avatarPreviewImages(): string[] {
            if (_.isEmpty(this.avatar)) {
                return [require(`@/assets/default_avatar_${this.info.gender.toLowerCase()}_preview.png`)];
            } else {
                return [this.avatar["downloadUrl"]];
            }
        }
    },
    async mounted() {
        await this.getOrgConfig();
        const basicInfoResp = await currentStudentBasicInfo();
        const identityInfoResp = await currentStudentIdentityInfo();
        this.info = { ...basicInfoResp.data.data, ...identityInfoResp.data.data };
        if (this.info.user) {
            this.info.englishName = this.info.user.englishName;
            this.info.phone = this.info.user.phone;
        }
        this.isForeign = this.info.nationalityType === NationalityType.FOREIGN;
        this.idCardFront = this.getPhoto(this.info.identity);
        this.idCardBack = this.getPhoto(this.info.identityBack);
        this.idPhoto = this.getPhoto(this.info.idPhoto);
        this.avatar = this.getPhoto(this.info.avatarResource);
        this.submitDisabled = false;
    },
    methods: {
        ...mapActions(["getOrgConfig"]),
        goToBasicInfoEdit() {
            this.isBasicInfoEdit = true;
        },
        goToIdentityEdit() {
            this.isIdentityEdit = true;
        },
        goToIDCardEdit() {
            this.isIDCardEdit = true;
        },
        getPhoto(photo: any) {
            return _.isEmpty(photo)
                ? {}
                : {
                      url: photo.thumbnailUrl,
                      downloadUrl: photo.downloadUrl
                  };
        },
        getImageSrc(image: any, defaultImg: string) {
            if (_.isEmpty(image)) {
                return require(`@/assets/${defaultImg}.png`);
            } else {
                return image["downloadUrl"];
            }
        },
        onAvatarClick() {
            this.showAvatarPreview = true;
        },
        onAvatarAfterRead(file: any) {
            this.showAvatarPreview = false;
            this.avatar = { isImage: true, status: "uploading" };
            this.submitDisabled = true;
            this["afterRead"](
                file,
                {
                    businessType: StorageBusinessType.USER,
                    prefixFileName: AttachmentCode.USER_AVATAR
                },
                (fileKey, downloadUrl, thumbnailUrl) => {
                    this.info.avatarFileKey = fileKey;
                    this.avatar = { isImage: true, key: fileKey, url: thumbnailUrl, downloadUrl: downloadUrl };
                    updateCurrentStudentBasicInfo({ avatarFileKey: fileKey, email: this.info.email }).then(ignore => {
                        this.$toast(this.$t("common.alert.saveSuccess"));
                    });
                },
                () => {
                    this.submitDisabled = false;
                }
            );
        }
    }
});
